import { render, staticRenderFns } from "./App.vue?vue&type=template&id=3480b25c&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/juodeliai/miskovezis-core/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3480b25c')) {
      api.createRecord('3480b25c', component.options)
    } else {
      api.reload('3480b25c', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=3480b25c&", function () {
      api.rerender('3480b25c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/resources/static/js/app/components/App.vue"
export default component.exports